import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type FreeTextFilter,
  type MultiFilter,
} from '../types/filters';
import { keywordsDefinition, keywordsHandler } from './keywords';

export const multiKeywordsDefinition: FilterDefinition<
  MultiFilter<FreeTextFilter>
> = {
  id: FilterId.MULTI_KEYWORDS,
  name: 'Keywords',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.KEYWORDS,
  instances: [],
  isVisible: true,
};

export const multiKeywordsHandler: FilterHandler<MultiFilter<FreeTextFilter>> =
  {
    isActive(currentFilterState: MultiFilter<FreeTextFilter>) {
      return currentFilterState.instances.some((instance) =>
        keywordsHandler.isActive(instance)
      );
    },

    isDefault(
      currentFilterState: MultiFilter<FreeTextFilter>,
      _definition: FilterDefinition<MultiFilter<FreeTextFilter>>
    ) {
      return currentFilterState.instances.length === 0;
    },

    getEffectiveFilter(
      currentFilterState: MultiFilter<FreeTextFilter>,
      _definition: FilterDefinition<MultiFilter<FreeTextFilter>>,
      config: FilterConfig
    ) {
      const effectiveInstances = currentFilterState.instances.map((instance) =>
        keywordsHandler.getEffectiveFilter(instance, keywordsDefinition, config)
      );
      return { ...currentFilterState, instances: effectiveInstances };
    },
  };
